import React from 'react'
import { Flex, Button, Box, Skeleton, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { useLocation, Link } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import Balance from 'components/Balance'
import { usePriceATALIRABusd, usePricebabyBusd, usePriceBnbBusd, usePriceBtntyBusd, usePricebuildBusd, usePriceBVCBusd, usePriceCakeBusd, usePricecubyBusd, usePriceETCBusd, usePriceETHBusd, usePriceEXZOBusd, usePriceLameaBusd, usePriceLGCBusd, usePriceliraBusd, usePriceLTCBusd, usePriceskeletonBusd, usePricetripBusd } from 'state/farms/hooks'

const Container = styled.div`
height: 50px;
width: 100%;
overflow: hidden;
position: relative;
justify-content: space-between;
  ${({ theme }) => theme.mediaQueries.md} {
    border-radius: 8px;
    height: 50px;
    overflow: hidden;
    width: 100%;
    position: relative;
    justify-content: space-between;
  }
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);

  ${({ theme }) => theme.mediaQueries.xs} {
    grid-gap: 16px;
    grid-template-columns: repeat(2, auto);
  }
  
  ${({ theme }) => theme.mediaQueries.sm} {
    grid-gap: 16px;
    grid-template-columns: repeat(2, auto);
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(4, auto);
    grid-gap: 32px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    grid-gap: 32px;
    grid-template-columns: repeat(4, auto);

  }  ${({ theme }) => theme.mediaQueries.xl} {
    grid-template-columns: repeat(4, auto);
    grid-gap: 32px;
  }
`

const ImageWrapper = styled.div`
flex: none;
margin: 0 auto;
margin-right: 5px;
${({ theme }) => theme.mediaQueries.md} {
  flex: none;
  margin: 0 auto;
  margin-right: 5px;

}
`
const floatingAnim = (x: string, y: string) => keyframes`
0% {transform: translate3d(0px, 0%, 0px);}
10% {transform: translate3d(0px, 0%, 0px);}
49.99999% {transform: translate3d(0px, 0%, 0px);}
50% {transform: translate3d(0px, -50px, 0px);}
99.9999% {transform: translate3d(0px, -50px, 0px);}
`


const Wrapper = styled(Box)`
position: relative;
animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
  animation-delay: 0s;
  ${({ theme }) => theme.mediaQueries.xs} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.md} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.xl} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
`
const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`


interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
}

const TopTokenMovers2: React.FC= () => {
  const { t } = useTranslation()

  const etcprice0 = usePriceETCBusd()
  const etcprice = etcprice0.toNumber()
  const buildprice0 = usePricebuildBusd()
  const buildprice = buildprice0.toNumber()
  const liraprice0 = usePriceliraBusd()
  const liraprice  = liraprice0.toNumber()
 const vizslaprice = usePriceCakeBusd()
 const vizslaprice0 = vizslaprice.toNumber()
 const ataliraprice0 = usePriceATALIRABusd()
 const ataliraprice = ataliraprice0.toNumber()
 const babyprice0 = usePricebabyBusd()
 const babyprice = babyprice0.toNumber()
 const btntyprice0 = usePriceBtntyBusd()
 const btntyprice = btntyprice0.toNumber()
 const cubyprice0 = usePricecubyBusd()
 const cubyprice = cubyprice0.toNumber()

  return (
  
    <Container>
                <Flex justifyContent="center" alignItems="center">
                <Grid>
             

  

      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x3d6545b08693daE087E957cb1180ee38B9e3c25E">
      <ImageWrapper>
        <img src="/images/wallet/20.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('ETC')}
        </ButtonText>
        {etcprice ? (
          <Balance fontSize="15px" prefix="$" decimals={2} value={etcprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
            </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x83b27De2Fca046FA63a11C7Ce7743DE33Ec58822">
      <ImageWrapper>
        <img src="/images/wallet/14.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('BUILD')}
        </ButtonText>
  {buildprice ? (
          <Balance fontSize="15px" prefix="$" decimals={5} value={buildprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}      
        </Flex >
      </Button>
      </Flex>
      </Wrapper>

      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0xadaae082237cb1772c9e079db95c117e6dd0c5af">
      <ImageWrapper>
        <img src="/images/wallet/2.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('VIZSLASWAP')}
        </ButtonText>
        {vizslaprice0 ? (
          <Balance fontSize="15px" prefix="$" decimals={5} value={vizslaprice0} />
        ) : (
          <Skeleton width={60} height={16} />
        )}   
         </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0xA80a006A48dc7203EB3AA7E0b3816918d242CFC4">
      <ImageWrapper>
        <img src="/images/wallet/15.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('LIRA')}
        </ButtonText>
        {liraprice ? (
          <Balance fontSize="15px" prefix="$" decimals={5} value={liraprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
          </Flex >
      </Button>
      </Flex>
      </Wrapper>

      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0xA4E26Bd6DCBa9021DCd3A1159BA52e97CD770b8a">
      <ImageWrapper>
        <img src="/images/wallet/21.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('BABY')}
        </ButtonText>
        {babyprice ? (
          <Balance fontSize="15px" prefix="$" decimals={4} value={babyprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}     
       </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x488907d99cE2ac919A47AcFac896e825Fd23598f">
      <ImageWrapper>
        <img src="/images/wallet/24.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('CUBY')}
        </ButtonText>
        {cubyprice ? (
          <Balance fontSize="15px" prefix="$" decimals={7} value={cubyprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
        </Flex >
      </Button>
      </Flex>
      </Wrapper>

      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x8604d31F3683A22b328CF6F974A34233c3494ccf">
      <ImageWrapper>
        <img src="/images/wallet/12.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('ATALIRA')}
        </ButtonText>
        {ataliraprice ? (
          <Balance fontSize="15px" prefix="$" decimals={4} value={ataliraprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}     
       </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0xF15c8d610E02602caAA9959BF5ecfEb8B3D229bE">
      <ImageWrapper>
        <img src="/images/wallet/17.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('BTNTY')}
        </ButtonText>
        {btntyprice ? (
          <Balance fontSize="15px" prefix="$" decimals={7} value={btntyprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
        </Flex >
      </Button>
      </Flex>
      </Wrapper>
      </Grid>
      </Flex>
      </Container>
  )
}

export default TopTokenMovers2
